/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import "../i18n"

import { Modal } from "../shared/actions/modal"
import { Toast } from "../shared/actions/toast"
import { Api } from "../shared/api/fetcher"
import { CusCookie } from "../shared/common/cookie"
import { CusDate } from "../shared/datetime/common"
import { TouristAutocomplete } from "../shared/filters/tourist_autocomplete"

import "./transfer"
import "./travel_book/admin_extension_tokens"
import "./travel_book/admin_saved_tours"
import "./travel_book/avia_v3"
import "./travel_book/bundle_sync"
import "./travel_book/bundles_list"
import "./travel_book/save_tours"
import "./travel_book/save_tours_session"
import "./travel_book/save_tours_settings"
import { eventBus } from "./utils/event_bus"
import "./widgets/widgets_entry"
import "./transfer_price_detail"
import "./transfer_prices"

console.log("Hello World from Webpacker")

window.Toast = Toast

window.Api = Api

window.Modal = Modal

window.CusDate = CusDate

window.CusCookie = CusCookie

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    Modal.closeModal()
  }
})

window.TouristAutocomplete = TouristAutocomplete
window.EventBus = eventBus
